import { createFileRoute } from "@tanstack/react-router";
import { AuthLayout } from "@/shared/layouts/auth-layout";
import { ForgotPasswordPage } from "@/shared/pages/auth/forgot-password";
import { requireGuest } from "@/shared/lib/auth-guard";

export const Route = createFileRoute("/auth/forgot-password")({
  beforeLoad: requireGuest,
  component: ForgotPasswordRoute,
});

function ForgotPasswordRoute() {
  return (
    <AuthLayout>
      <ForgotPasswordPage />
    </AuthLayout>
  );
}
